import { useQuery } from '@tanstack/react-query';
import {
  AutoDocumentExtractionsByField,
  getAllAutoDocumentExtractions,
} from 'query/study';

export type UseAllAutoDocumentExtractionsArgs = {
  enabled: boolean;
  studyId: number;
  documentId: number | undefined;
};

// Every suggestion for a document in one request, for callers that need to
// reason about fields the reviewer has not looked at. Unlike the per-field
// query this does not mark suggestions as surfaced.
export const useAllAutoDocumentExtractions = ({
  enabled,
  studyId,
  documentId,
}: UseAllAutoDocumentExtractionsArgs) => {
  return useQuery({
    queryKey: ['allAutoDocumentExtractions', studyId, documentId],
    queryFn: (): Promise<AutoDocumentExtractionsByField | null> => {
      if (!documentId) return Promise.resolve({});
      return getAllAutoDocumentExtractions({ documentId, studyId });
    },
    staleTime: 60_000, // cache results for 1 minute
    enabled: enabled && Boolean(documentId),
  });
};
